<template>
  <b-overlay
    :show="loader.formulario"
    opacity="0.50"
    rounded="sm"
  >
    <component :is="'div'">
      <!-- Alert: No item found -->
      <b-alert
        variant="danger"
      />
      <b-card>
        <template>
          <b-tabs
            vertical
            nav-wrapper-class="nav-vertical"
          >
            <b-tab :active="(typeof $route.params.tab!=='undefined')?$route.params.tab[0]:true">
              <template #title>
                <feather-icon
                  icon="FlagIcon"
                  size="16"
                  class="mr-0 mr-sm-50"
                />
                <span class="d-none d-sm-inline">Aspirantes</span>
              </template>
              <reporte-aspirantes
                :loader="loader"
                class="mt-2 pt-75"
                @update:loader="loader = $event"
              />
            </b-tab>
            <!-- Tab: Persona -->
            <b-tab :active="(typeof $route.params.tab!=='undefined')?$route.params.tab[1]:false">
              <template #title>
                <feather-icon
                  icon="UsersIcon"
                  size="16"
                  class="mr-0 mr-sm-50"
                />
                <span class="d-none d-sm-inline"> Alumnos</span>
              </template>
              <reportes-filters
                :loader="loader"
                class="mt-2 pt-75"
                @update:loader="loader = $event"
              />
            </b-tab>
          </b-tabs>
        </template>
      </b-card>
    </component>
  </b-overlay>
</template>

<script>
import store from '@/store'
import { ref, onUnmounted } from '@vue/composition-api'
import {
  BTab, BTabs, BCard, BAlert, BOverlay,
} from 'bootstrap-vue'
import reportesFilters from '@/views/campus/components/reportes/components/reportesFilters.vue'
import reporteAspirantes from '@/views/campus/components/reportes/components/reporteGralFilters.vue'

export default {
  components: {
    BTab,
    BTabs,
    BCard,
    BOverlay,
    BAlert,
    reportesFilters,
    reporteAspirantes,
  },
  setup() {
    const USER_APP_STORE_MODULE_NAME = 'app-user'

    const loader = ref({ formulario: false })

    onUnmounted(() => {
      if (store.hasModule(USER_APP_STORE_MODULE_NAME)) store.unregisterModule(USER_APP_STORE_MODULE_NAME)
    })
    return {
      loader,
    }
  },

}
</script>
